import * as React from 'react';
import {
  Router as ReactRouter,
  Route,
  Redirect,
  browserHistory,
} from 'react-router';

import FormPage from '../containers/FormPage';
// import Request from '../components/request'
import MainPage from '../containers/MainPage';
import Auth from '../containers/Auth';
import Mentor from '../containers/Mentor';

import {
  SITE_URL,
  FORMS_ROUTE,
  MENTORS_URL,
  MENTORS_FORMS_ROUTE,
} from './urls';

export const history = browserHistory;

const Router = () => {
  return (
    <Auth>
      <ReactRouter history={history}>
        <Redirect from="/" to={SITE_URL} />
        <Route path={FORMS_ROUTE} component={FormPage} />
        <Route path={MENTORS_FORMS_ROUTE} component={FormPage} />
        <Route path={SITE_URL} component={MainPage} />
        <Route path={MENTORS_URL} component={Mentor} />
        <Route
          path={SITE_URL + '404'}
          component={() => <p>ERROR 404: Route not found</p>}
        />
        <Redirect from="*" to={SITE_URL + '404'} />
      </ReactRouter>
    </Auth>
  );
};

export default Router;
